module.exports = __webpack_public_path__ + "img/25.ff73d8c3.png";